import { render, staticRenderFns } from "./studentCourseCatalogue.vue?vue&type=template&id=a0faa6da&"
import script from "./studentCourseCatalogue.vue?vue&type=script&lang=js&"
export * from "./studentCourseCatalogue.vue?vue&type=script&lang=js&"
import style0 from "./studentCourseCatalogue.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "studentCourseCatalogue.vue"
export default component.exports